module.exports = __webpack_public_path__ + "699d85a94bc3b2cf259d012c66504f1e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/mythos-1.jpg
// module id = 807
// module chunks = 0